import React, { useState, useEffect } from "react";
import style from "./About.module.css";
import { fetchDam } from "../../API";
import ReactRotatingText from "react-rotating-text";
import { useSpring, animated } from "react-spring";
import Navbar from "../Navbar/Navbar";
import Loader from "../Loader/Loader";
import Aos from "aos";
import "aos/dist/aos.css";

import { Link } from "react-router-dom";

import btnLeft from "../../Images/Update 2.1/Button Left.svg";
import btnRight from "../../Images/Update 2.1/Button Right.svg";
import AboutPhoto from "../../Images/Update 2.1/profileImg.svg";
import remoteImg from "../../Images/Update 2.1/RemoteImg.svg";
import listImg from "../../Images/Update 2.1/listImg.svg";

const About = ({ toggle, state, x, setAboutPageServer, aboutpageServer }) => {
  const ref1 = React.createRef();
  const item_ref = React.createRef();
  const click_next = React.createRef();

  const [scrollNo, setScrollNo] = useState(1);

  const ScrollNext = () => {
    let scroller = ref1.current;
    let itemWidth = item_ref.current.clientWidth;

    if (scroller.scrollLeft < scroller.scrollWidth - itemWidth) {
      scroller.scrollBy({ left: itemWidth, top: 0, behavior: "smooth" });

      setScrollNo(scrollNo + 1);
    } else {
      scroller.scrollTo({ left: 0, top: 0, behavior: "smooth" });
      setScrollNo(1);
    }
  };

  const ScrollPrev = () => {
    let scroller = ref1.current;
    let itemWidth = item_ref.current.clientWidth;

    if (scroller.scrollLeft !== 0) {
      scroller.scrollBy({ left: -itemWidth, top: 0, behavior: "smooth" });
      setScrollNo(scrollNo - 1);
    } else {
      scroller.scrollTo({
        left: scroller.scrollWidth,
        top: 0,
        behavior: "smooth",
      });
      setScrollNo(aboutPageSect3.length);
    }
  };

  const [benPlatform, setBenPlatform] = useState([]);
  const [stopper, setStopper] = useState(null);
  const [images, setImages] = useState({
    logo:
      "https://res.cloudinary.com/oyindacodes/image/upload/v1605096991/logo_nh5kui.svg",
    Fb_Img:
      "https://res.cloudinary.com/oyindacodes/image/upload/v1605096988/facebook_yuritk.svg",
    Ig_Img:
      "https://res.cloudinary.com/oyindacodes/image/upload/v1605096990/instagram_pevhyd.svg",
    be_Img:
      "https://res.cloudinary.com/oyindacodes/image/upload/v1605096988/behance_ukv0je.svg",
    lk_Img:
      "https://res.cloudinary.com/oyindacodes/image/upload/v1605096990/linkedin-3_p4yh62.svg",
    tw_Img:
      "https://res.cloudinary.com/oyindacodes/image/upload/v1605096993/twitter_prkdsa.svg",
    mouseImg:
      "https://res.cloudinary.com/oyindacodes/image/upload/v1605096992/mouse_qwtl1u.svg",
    mcBookImg:
      "https://res.cloudinary.com/oyindacodes/image/upload/v1605021641/Macbook_o9y5ch.svg",
    gitImg:
      "https://res.cloudinary.com/oyindacodes/image/upload/v1606221517/github-seeklogo.com_w7n0ml.svg",
  });

  const fetchAPI = async () => {
    setTimeout(async () => {
      setBenPlatform(await fetchDam());
    }, 2000);
  };
  useEffect(() => {
    fetchAPI();
  }, [stopper]);

  useEffect(() => {
    Aos.init({
      duration: 1000,
    });
  });

  benPlatform ? setAboutPageServer(true) : setAboutPageServer(false);
  const {
    aboutPage,
    aboutPageSect2,
    aboutPageSect3,
    aboutPageSect4,
    aboutPageSect5,
  } = benPlatform;

  return aboutPage &&
    aboutPageSect2 &&
    aboutPageSect3 &&
    aboutPageSect4 &&
    aboutPageSect5 ? (
    <section>
      <animated.div>
        <div>
          <div className={style.linkSmallScreen}>
            <img src={images.logo} alt="logo" className={style.logo} />
            <div className={style.hambuger2} onClick={() => toggle(true)}>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className={style.overallCnt}>
            <div className={style.works}>
              <img className={style.logo} src={images.logo} alt="logo" />
              <p className={style.para}>Oyindacodes 2020</p>
            </div>
            <div className={style.carousel}>
              <div className={style.carousel2}>
                <div className={style.innerDiv}>
                  <h1>
                    <ReactRotatingText
                      items={benPlatform.aboutPageTitles}
                      pause={2000}
                      typingInterval={100}
                      cursor={false}
                    />
                  </h1>
                </div>
              </div>
            </div>
            <div className={style.contact}>
              <div className={style.innerDiv2}>
                <div className={style.hambuger} onClick={() => toggle(true)}>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <p className={style.para2}>Contact Me</p>
                <div className={style.links}>
                  <a href="https://www.instagram.com/oyindamolaakogun/">
                    <img
                      src={images.Ig_Img}
                      className={style.linkImg}
                      alt="Instagram logo"
                    />
                  </a>
                  <a href="https://twitter.com/AkogunOyindamo3">
                    <img
                      src={images.tw_Img}
                      className={style.linkImg}
                      alt="twitter logo"
                    />
                  </a>
                  <a href="https://www.facebook.com/oyindamola.akogun/">
                    <img
                      src={images.Fb_Img}
                      className={style.linkImg}
                      alt="Facebook logo"
                    />
                  </a>

                  <a href="https://github.com/damoski2">
                    <img
                      src={images.gitImg}
                      className={style.linkImg}
                      alt="github logo"
                    />
                  </a>

                  <a href="" target="_blank">
                    <img
                      src={images.lk_Img}
                      className={style.linkImg}
                      alt="Linkedin logo"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </animated.div>
      <section className={style.OvlAbt} >
      <div className={style.container}>
        <div data-aos={"fade-up"} className={style.mainAbout}>
          <h1 className={style.headingPara}>{aboutPage.heading}</h1>
          <h1 className={style.headingName}>{aboutPage.headingName}</h1>
          <p className={style.p_ara}>{aboutPage.details}</p>
          <br />
          <br />
          <a className={style.webLink} href="http://rampion-tech.netlify.app">
            Visit our Site
          </a>
        </div>
      </div>
      <div data-aos={"fade-up"} className={style.sect2}>
        <div className={style.innerSect2}>
          <img src={AboutPhoto} />
          <div>
            <h1>{aboutPageSect2.heading}</h1>
            <p>{aboutPageSect2.details}</p>
          </div>
        </div>
      </div>
      <div className={style.sect3}>
        <div ref={ref1} className={style.innerSect3}>
          {aboutPageSect3.map((item) => (
            <div ref={item_ref} className={style.designP}>
              <div >
                <h1>{item.heading}</h1>
                <p>{item.details}</p>
              </div>
              <img src={item.img} className={style.SketchImg} />
            </div>
          ))}
        </div>
        <div className={style.navigators}>
          <img src={btnLeft} onClick={ScrollPrev} className={style.btnLeft} />
          <img src={btnRight} onClick={ScrollNext} className={style.btnRight} />
          <span className={style.number}>0{scrollNo}</span>
        </div>
      </div>

      <div className={style.sect4}>
        <div className={style.innerSect4}>
          <img  data-aos={"fade-right"} className={style.img1} src={remoteImg} alt="project Image" />
          <div  data-aos={"fade-left"} className={style.projectInfo}>
            <h1>{aboutPageSect4.heading}</h1>
            <p className={style.para3}>{aboutPageSect4.para1}</p>
            <p className={style.para4}>{aboutPageSect4.para2}</p>
            <Link className={style.viewLink} to="/contact">
              Let's Work together
            </Link>
          </div>
        </div>
      </div>

      <div className={style.sect5}>
        <div className={style.innerSect5}>
          <div className={style.serviceInfo}>
            <h1>{aboutPageSect5.heading}</h1>
            <p>{aboutPageSect5.details}</p>
          </div>
          <div className={style.services}>
            {aboutPageSect5.services.map((item) => (
              <div className={style.actualService}>
                <img src={item.img} />
                <h3>{item.header}</h3>
                {item.options.map((option) => (
                  <div>
                    <img src={listImg} />
                    <p>{option}</p>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
      </section>
    </section>
  ) : (
    <Loader aboutpageServer={aboutpageServer} />
  );
};

export default About;
